import React from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";


const About = () => {
    const title = 'About Us';
    const description = 'Zeodel Technologies Private Limited is a software company that builds modern digital solutions for businesses. We combine technical expertise with a clear understanding of your goals to deliver web applications, mobile apps, and custom software that scale with you. Whether you need a new website, a mobile app, or end-to-end digital strategy and reporting, we work with you from idea to launch and beyond.';

    return (
        <React.Fragment>
            <PageHelmet pageTitle='About'/>

            <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png"/>
            <Breadcrumb title={'About Us'}/>

            <div className="rn-about-area ptb--120 bg_color--1">
                <div className="rn-about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">
                            <div className="col-lg-5">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/software-team.jpg"
                                         alt="About Zeodel Technologies"/>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">Who we are</h3>
                                                <p>We are a team of engineers and designers focused on building reliable, user-friendly software that helps businesses grow and operate more efficiently.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">What we do</h3>
                                                <p>From web and mobile development to strategy and reporting, we deliver end-to-end solutions tailored to your industry and requirements.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>







            <Footer/>

        </React.Fragment>
    )
};

export default About
